export const GAAddToWishList = (product) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  const itemCategory2 = product.metal ? { item_category2: product.metal } : {}
  const itemCategory3 = product.metal_color ? { item_category3: product.metal_color } : {}
  const itemCategory4 = product.product_collection ? { item_category4: product.product_collection } : {}
  dataLayer.push({
    event: "add_to_wishlist",
    ecommerce: {
      items: [
        {
          item_name: product.name,
          item_id: product.sku,
          price: product.price.current,
          item_category: product.category,
          quantity: 1,
          ...itemCategory2,
          ...itemCategory3,
          ...itemCategory4,
        },
      ],
    },
  });
};
